import { faCircleCheck, faCircleXmark } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ExternalLink } from "~/components/site/external-link";
import type { Wallet, WalletId } from "~/lib/ecosystem";
import { WALLETS } from "~/lib/ecosystem";

type Props = Readonly<{
  selectedWallets: WalletId[];
}>;

export function Wallets({ selectedWallets }: Props): JSX.Element {
  const walletMap = new Map<string, Wallet>();

  WALLETS.forEach((wallet) => {
    walletMap.set(wallet.id, wallet);
  });

  const filteredWallets = selectedWallets
    .map((id) => walletMap.get(id) as Wallet)
    .filter(Boolean);

  const renderIcon = (condition = true) => (
    <FontAwesomeIcon
      className={`h-6 w-6 ${
        condition
          ? "text-purple-500"
          : "mx-auto text-gray-500 dark:text-gray-400"
      }`}
      icon={condition ? faCircleCheck : faCircleXmark}
    />
  );

  return (
    <div className="border border-primary round overflow-x-scroll bg-white dark:bg-black p-6 md:p-8 mt-8 mb-8">
      <table className="table-auto m-0">
        <thead>
          <tr>
            <th></th>
            {filteredWallets.map((w) => (
              <th key={w.name} className="not-prose">
                <div className="mx-auto w-12 mb-2 px-2">
                  <ExternalLink href={w.url} title={`Visit ${w.name} Wallet`}>
                    <img
                      alt={`${w.name} Wallet icon | Brale`}
                      src={w.icon}
                      className="round border border-primary"
                    />
                  </ExternalLink>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <th className="pr-4">Supports new stablecoins</th>
            {filteredWallets.map((w) => (
              <td key={w.name} className="pr-2 px-2">
                <div className="h-6 w-6 mx-auto">{renderIcon(w.support)}</div>
              </td>
            ))}
          </tr>
          <tr>
            <th className="pr-4">Automatic recognition</th>
            {filteredWallets.map((w) => (
              <td key={w.name} className="pr-2 px-2">
                <div className="h-6 w-6 mx-auto">
                  {renderIcon(w.recognition)}
                </div>
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
